import React, { Component } from 'react';

import './Info.scss';

class Info extends Component {
    render() {
        return (
            <div className="Info">
                <div className="info-container">
                    <div className="content-section">

                        <div className="content-element">
                            <span className="content-title">Info</span>
                            <div className="content-list">
                                <p className="list-item full">April 27, &nbsp; <a className="link" href="https://goo.gl/maps/KnGEZ9Qvjno" target="_blank" >Keller Auditorium</a></p>
                            </div>
                        </div>

                        <div className="content-element">
                            <span className="content-title">History</span>
                            <div className="content-list">
                                <p className="list-item full">TEDxPortland is an independently organized TED event. In its ninth consecutive year, it has a rich history of spreading ideas, sharing knowledge and building community in&nbsp;Portland.<br />&nbsp;</p>
                                {/* <p className="list-item full"><a href="http://history.tedxportland.com">http://history.tedxportland.com</a></p> */}
                            </div>
                        </div>

                        <div className="content-element">
                            <span className="content-title">Social</span>
                            <div className="content-list">
                                <a className="list-item link" href="https://www.facebook.com/TEDxPortland/" target="_blank" >Facebook</a>
                                <a className="list-item link" href="https://www.instagram.com/tedxportland/" target="_blank" >Instagram</a>
                                <a className="list-item link" href="https://twitter.com/TEDxPortland" target="_blank" >Twitter</a>
                                <a className="list-item link" href="https://www.youtube.com/watch?v=CFgqFbbEYcU&list=PLsRNoUx8w3rP0OBajy2AMQ8thQEVEPZi9" target="_blank" >YouTube</a>
                            </div>
                        </div>

                        <div className="content-element">
                            <span className="content-title">Creative</span>
                            <div className="content-list">
                                <a className="list-item link" href="http://enjoytheweather.com" target="_blank" >Enjoy the Weather</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Info;